<div *ngIf="order$ | async as order" class="eb-review-summary row">
  <ng-container>
    <div class="col-sm-6 col-md-4 col-lg-4">
      <eb-card
        *ngIf="order?.code || order?.salesDocNumber"
        [ghost]="true"
        class="eb-review-card"
        [content]="getOrderCodeCardContent(order?.code || order?.salesDocNumber) | async"
      ></eb-card>
      <ng-container *ngTemplateOutlet="paymentType"></ng-container>
      <ng-container *ngTemplateOutlet="shippingAddress"></ng-container>
    </div>
    <div class="col-sm-6 col-md-4 col-lg-4">
      <ng-container *ngTemplateOutlet="poNumber"></ng-container>
      <ng-container *ngTemplateOutlet="orderedBy"></ng-container>
      <ng-container *ngTemplateOutlet="invoiceAddress"></ng-container>
    </div>
    <div class="col-sm-6 col-md-4 col-lg-4">
      <eb-card
        *ngIf="order?.created || order?.createdAt"
        [ghost]="true"
        class="eb-review-card"
        [content]="getOrderCurrentDateCardContent(order?.created || order?.createdAt) | async"
      ></eb-card>
      <ng-container *ngTemplateOutlet="deliveryMode"></ng-container>
    </div>
  </ng-container>

  <!-- INVOICE ADDRESS SECTION -->
  <ng-template #invoiceAddress>
    <div
      *ngIf="order?.paymentAddress || order?.partners"
      data-cy="invoice-address"
      class="eb-review-summary-card"
    >
      <eb-card
        [content]="getInvoiceAddressCard(order?.paymentAddress || order?.partners) | async"
        [ghost]="true"
        class="eb-review-card"
      ></eb-card>
    </div>
  </ng-template>

  <!-- SHIPPING ADDRESS SECTION -->
  <ng-template #shippingAddress>
    <ng-container class="eb-review-summary-card" *ngIf="order?.deliveryAddress || order?.partners">
      <eb-card
        [ghost]="true"
        [content]="getAddressCardContent(order?.deliveryAddress || order?.partners) | async"
        class="eb-review-card"
        data-cy="shipping-address"
      ></eb-card>
    </ng-container>
  </ng-template>

  <ng-template #shippingDate>
    <ng-container class="eb-review-summary-card" *ngIf="order?.shippingDate">
      <eb-card
        [ghost]="true"
        [content]="getOrderShippingDateCardContent(order?.shippingDate) | async"
        class="eb-review-card"
      ></eb-card>
    </ng-container>
  </ng-template>

  <!-- DELIVERY MODE SECTION -->
  <ng-template #deliveryMode>
    <div class="eb-review-summary-card" data-cy="delivery-mode">
      <ng-container *ngIf="order?.deliveryMode || selectedDeliveryMode">
        <eb-card
          [ghost]="true"
          [content]="
            getDeliveryModeCard(
              order?.deliveryMode || selectedDeliveryMode,
              (order?.shippingDate | cxDate: 'mediumDate' : 'UTC') || (order?.requestedShippingDate | cxDate: 'mediumDate' : 'UTC'),
              order?.completeDelivery
            ) | async
          "
          class="eb-review-card"
        ></eb-card>
      </ng-container>
    </div>
  </ng-template>

  <!-- ORDERED BY -->
  <ng-template #orderedBy>
    <div class="eb-review-summary-card">
      <ng-container *ngIf="order.purchasedByName">
        <eb-card
          [ghost]="true"
          [content]="getOrderedByCard(order.purchasedByName) | async"
          class="eb-review-card"
        ></eb-card>
      </ng-container>
    </div>
  </ng-template>

  <!-- PO NUMBER SECTION -->
  <ng-template #poNumber>
    <div class="eb-review-summary-card">
      <eb-card
        [ghost]="true"
        [content]="getPoNumberCard(order?.poNumber || order?.purchaseOrderNumber) | async"
        class="eb-review-card"
      ></eb-card>
    </div>
  </ng-template>

  <!-- PAYMENT TYPE SECTION -->
  <ng-template #paymentType>
    <div class="eb-review-summary-card" data-cy="payment-type">
      <eb-card
        [ghost]="true"
        [content]="getPaymentTypeCard() | async"
        class="eb-review-card"
      ></eb-card>
    </div>
  </ng-template>
</div>
